import React from 'react';
import styles from './card.module.css';
import CardTitle from '../../../../lib/component/cardTitle/cardTitle';
import CardItem from '../../../../lib/component/card2Item/cardItem';
import { BoutiqueItem } from '../../js/interface';
import statisticsApi from '../../../../lib/statisticsApi';

export default ({ title, bookArr, fn }: { title: string; bookArr: BoutiqueItem[]; fn: Function | null }) => {
  function tipText() {
    if (title === '重磅推荐') {
      return '';
    } else {
      return '更多';
    }
  }

  const arr = ['重磅推荐', '男生最爱', '女生最爱', '完结作品'];
  const arrr = [81, 82, 83, 84];

  function ck() {
    for (let i = 0; i < arr.length; i++) {
      if (title === arr[i]) {
        statisticsApi.statisticsApi(arrr[i]);
      }
    }
  }

  return (
    <>
      <div className={styles.card}>
        <CardTitle {...{ title: title, tip: tipText(), fn: fn }}></CardTitle>
        <div className={styles.cardContent}>
          {bookArr.map((item, index) => {
            return (
              <CardItem
                {...{
                  type: title === '重磅推荐' ? 0 : 1,
                  index: index,
                  book: item.book,
                  ck: ck,
                }}
                key={index}
              ></CardItem>
            );
          })}
        </div>
      </div>
    </>
  );
};
